
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CargosDetallesService } from "../../servicios/cargos-detalles.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { CargosDetalles, CatUsuarios } from "../../entidades/entidades";
import { CargosDetallesInput } from "../../entidades/entidades";

// ========================================================================

// ==========================================================================


declare var $: any;


// =====================================================================

// ======================================================================


@Component({
  selector: 'app-cargos-detalles-online',
  templateUrl: './cargos-detalles-online.component.html',
  styleUrls: ['./cargos-detalles-online.component.css']
})
export class CargosDetallesOnlineComponent implements OnInit {
 muestraMensaje = new MuestraMensaje();
  @Input("cargosDetallesInput") cargosDetallesInput: CargosDetallesInput;
  @Output("cargosDetallesOutput") cargosDetallesOutput: EventEmitter<CargosDetallesInput>;
  @Output("totalAdeudoOutput") totalAdeudoOutput: EventEmitter<number>;
  @Output("totalAnomalisOutput") totalAnomalisOutput: EventEmitter<number>;
  @Output() busquedaFinalizada: EventEmitter<void> = new EventEmitter<void>();
  @Input() bloquearCheck: boolean = false;
  @Input() tipoCargos: boolean = false;

  // ======================================================
  
 
  // =======================================================

  cargosDetallesTable: CargosDetalles[];
  catUsuario: CatUsuarios;
  public total: number = 0;
  public noAnomalias : number = 0;
  selectedAll: any;
  buscando: boolean = false;

  columnasTabla: any[];
  headerRows: any[];
  colsHeaderDet: any[];
  


  cols: any[];

  estimadoAnual: boolean = false;
  activoEstimadoAnual: boolean = false;

  public con_Convenio: boolean = false ;
  public con_anomalias:boolean=false;
  con_Cargo:boolean= true;
  public _totalAdeudo=0;
  public flagShowTab: boolean = false;

  constructor(private cargosDetallesService: CargosDetallesService,
) {
    
    this.cargosDetallesOutput = new EventEmitter();
    this.totalAdeudoOutput = new EventEmitter();
    this.totalAnomalisOutput = new EventEmitter();
    
     }
   ngOnInit() {
    //carga cfdi

    //pre carga datos.


    // ===============================================================
    //Opciones de la tabla
    // ==============================================================

    // prettier-ignore
    this.cols = [
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
      { field: "" },
    ];



    this.columnasTabla = [
      { field: "tipo", styleHeader: "width: 60px;" },
      { field: "descripcion", styleHeader: "width: 240px;" },
      { field: "anio", styleHeader: "width: 60px;" },
      { field: "bimestre", styleHeader: "width: 60px;" },
      { field: "total", styleHeader: "width: 110px;" },
  

    ];
 

  }

  ngOnChanges() {

    if (this.cargosDetallesInput) {
      this.cargosDetallesInput.conEstimadoAnual = false;
      this.cargosDetallesInput.ejecutaCalculo = true;
      this.cargosDetallesInput.borrarEstimado = true;
      this.cargosDetallesInput.conCargo = this.con_Cargo;
      this.cargosDetallesInput.conConvenio = this.con_Convenio;
      this.getCargosDetalles(this.cargosDetallesInput);
  
    }
  }

  ngAfterViewInit() { }

  // prettier-ignore
  async ejecutaEstimadoAnual(e) {

    var conEstimadoAnual = e.checked;
    this.cargosDetallesInput.conEstimadoAnual = conEstimadoAnual;
    this.cargosDetallesInput.borrarEstimado = !conEstimadoAnual;
    this.cargosDetallesInput.conCargo=  this.con_Cargo=true;
    this.cargosDetallesInput.conConvenio=this.con_Convenio=false;
    await this.getCargosDetalles(this.cargosDetallesInput);

    if (conEstimadoAnual) {
      this.selectedAll = true;
      this.selectAll();
    }
    this.activoEstimadoAnual = conEstimadoAnual;

  }

    // prettier-ignore
  async conCargo(e) {

    var conCargo = e.checked;
    this.cargosDetallesInput.conCargo = conCargo;
    this.cargosDetallesInput.conConvenio = this.con_Convenio = false;
    // this.cargosDetallesInput.conEstimadoAnual = this.estimadoAnual = false;
    


    console.log('CON CARGOS', this.cargosDetallesInput );
    await this.getCargosDetalles(this.cargosDetallesInput);




  }
    // prettier-ignore
  async conConvenio(e) {

    var conConvenio = e.checked;
    this.cargosDetallesInput.conConvenio = this.con_Convenio = conConvenio;
    this.cargosDetallesInput.conCargo = this.con_Cargo = false;
    this.cargosDetallesInput.conEstimadoAnual = this.estimadoAnual = false;
  

    console.log('CON CONVENIO', this.cargosDetallesInput );
    await this.getCargosDetalles(this.cargosDetallesInput);



  }
  get _totalAdeudoRedondeado() {
    return Math.round(this._totalAdeudo);
  }

  // prettier-ignore
  async getCargosDetalles(cargosDetallesInput: CargosDetallesInput) {
    if (this.buscando) {
      return;
    }
    try {

      this.buscando = true;
      const datoRetorno = await this.cargosDetallesService.getBusquedas(cargosDetallesInput).toPromise();
      this.cargosDetallesTable = datoRetorno;
      if (this.cargosDetallesTable.length>0){
        if (this.cargosDetallesTable[0].id==-1){
          this.muestraMensaje.notification(this.cargosDetallesTable[0].estatus, "top", "center");
        }
      }else if(this.cargosDetallesTable.length == 0){
        this.muestraMensaje.notification("Su cuenta se encuentra al corriente", "top", "center");
      }
      console.log("Cargos", datoRetorno);

      {//Se obtiene el total del adeudo
        let totalAdeudo = Math.ceil( Math.max(...this.cargosDetallesTable.map((o) => o.acumulado), 0));
        this.totalAdeudoOutput.emit(totalAdeudo);
        this._totalAdeudo = totalAdeudo;
      }

      {// Se obtiene las anomalias
        const numero = Object.keys(datoRetorno);

        for(var i of numero) {
          if (this.cargosDetallesTable[i].anomalia != null && this.cargosDetallesTable[i].anomalia != "MEDIDOR NUEVO" && this.cargosDetallesTable[i].anomalia != "PROMEDIO" ) {
            this.noAnomalias = this.noAnomalias + 1;
            console.log('Anomalias', i);
          }
        }
        let noAnomalia = this.noAnomalias;
        this.totalAnomalisOutput.emit(noAnomalia);
        console.log('Total de Anomalias', this.noAnomalias);
        if(this.noAnomalias>0)
          this.con_anomalias=true;
        
      }

    } catch (e) {
      if (e.response) { throw { message: e.response.data, }; } else { throw e; }
    } finally {
      console.log("Paso por getCargosDetalles");
      this.buscando = false;
      this.busquedaFinalizada.emit();
    }
  }

  // prettier-ignore
  async aplicaReglaSeleccion(index: number, row: any) {
    if (this.estimadoAnual) {
      this.estimadoAnual = false;
      await this.ejecutaEstimadoAnual(false);

    }

    this.total = 0;
    if (row.selected) {
      for (let x = index; 0 <= x; x--) {
        this.cargosDetallesTable[x].selected = true;
      }
    } else {
      for (let x = index; x < this.cargosDetallesTable.length; x++) {
        console.log("num bucle", x);
        this.cargosDetallesTable[x].selected = false;
      }
    }

    this.total = Math.max(...this.cargosDetallesTable.filter((item) => item.selected).map((o) => o.acumulado), 0);
    this.cargosDetallesOutput.emit(this.cargosDetallesInput);
  }

  async selectAll() {
    if (this.activoEstimadoAnual) {
      this.estimadoAnual = false;
      await this.ejecutaEstimadoAnual(this.estimadoAnual);
    }

    for (var i = 0; i < this.cargosDetallesTable.length; i++) {
      if (this.selectedAll) this.cargosDetallesTable[i].selected = true;
      else this.cargosDetallesTable[i].selected = false;
    }

    for (var i = 0; i < this.cargosDetallesTable.length; i++) {
      this.total = 0;
      if (this.cargosDetallesTable[i].selected) {
        for (let x = i; 0 <= x; x--) {
          this.cargosDetallesTable[x].selected = true;
        }
        this.total = Math.max(...this.cargosDetallesTable.map((o) => o.acumulado), 0);
      } else {
        for (let x = i; x < this.cargosDetallesTable.length; x++) {
          console.log("num bucle", this.cargosDetallesTable[x]);
          this.cargosDetallesTable[x].selected = false;
        }
        this.total = 0;
      }
    }
    this.cargosDetallesOutput.emit(this.cargosDetallesInput);
  }
  
 
}
